import { useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import { CrudPanel } from "@/components/library/CrudPanel";
import { money } from "@/lib/api";

export default function SettingsPricing() {
  const { user } = useAuth() as any;
  const admin = user?.role === "admin";
  return (
    <AppShell title="Settings · Pricing">
      <div className="space-y-8">
        <CrudPanel path="line-items" title="Line Items" testid="line-items" canEdit={admin}
          fields={[
            { key: "name", label: "Name" }, { key: "description", label: "Description", type: "textarea", hideInTable: true },
            { key: "category", label: "Category", type: "select", options: ["lighting", "decor", "service", "addon"].map((v) => ({ value: v, label: v })) },
            { key: "unit", label: "Unit" }, { key: "unit_price", label: "Unit price", type: "number", render: (r) => money(r.unit_price) },
            { key: "is_addon", label: "Optional add-in", type: "checkbox" },
            { key: "components", label: "Included components (one per line, shown next to the price)", type: "lines", hideInTable: true },
          ]} />
        <CrudPanel path="discounts" title="Discounts" testid="discounts" canEdit={admin}
          fields={[
            { key: "name", label: "Name" }, { key: "type", label: "Type", type: "select", options: [{ value: "percent", label: "Percent of subtotal" }, { value: "fixed", label: "Fixed amount" }] },
            { key: "value", label: "Value", type: "number", render: (r) => (r.type === "percent" ? `${r.value}%` : money(r.value)) }, { key: "description", label: "Description" },
          ]} />
      </div>
    </AppShell>
  );
}
